import { useState } from 'react'
import { twMerge } from 'tailwind-merge'
import LikeIcon from 'shared/icons/like-icon'
import { RequireAtLeastOne } from 'shared/types/at-least-one'
import { OnErrorType } from 'modules/comments/types'
import { useHover } from '../../hooks/use-hover'
import { LikeDetailPopover } from './like-detail-popover'

interface LikeSection {
  className?: string
  isLiked: boolean
  likesCount: number

  postId: number
  commentId: number

  readOnly?: boolean
  handleLikeClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  onError?: OnErrorType
}

export type LikeSectionProps = RequireAtLeastOne<LikeSection, 'postId' | 'commentId'>

export const LikeButton = ({
  className,
  isLiked,
  likesCount,
  postId,
  commentId,
  readOnly,
  handleLikeClick,
}: LikeSectionProps) => {
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null)
  const { hovered, ref: hoverRef } = useHover()

  return (
    <>
      <button
        type="button"
        disabled={readOnly}
        onClick={handleLikeClick}
        className={twMerge(
          'group relative inline-flex h-10 items-end gap-2 rounded-md px-1.5 py-2 text-text-tertiary *:transition-colors hover:bg-brand-primary/20',
          className,
        )}
      >
        <LikeIcon
          data-liked={isLiked}
          className="size-5 fill-none stroke-text-secondary group-hover:stroke-brand-primary data-[liked=true]:fill-brand-primary data-[liked=true]:stroke-brand-primary"
        />
        {likesCount > 0 && (
          <div ref={hoverRef} className="flex items-end">
            <span className="h-6" ref={setReferenceElement}>
              {likesCount}
            </span>
          </div>
        )}
      </button>
      {hovered && (
        <LikeDetailPopover
          postId={postId}
          commentId={commentId}
          likesCount={likesCount}
          referenceElement={referenceElement}
        />
      )}
    </>
  )
}
